<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="">
                <h3 class="card-title text-primary mb-0">Espacios</h3>
                <div class="sub-line"></div>
              </div>
              <div class="mt-2">
                  <router-link
                    :to="{ name: 'Crear-Natural' }"
                    class="btn btn-primary text-white bg-blue-600 rounded-lg hover:bg-blue-900 mb-0  ml-auto"
                  >Nuevo Espacio
                  </router-link>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 col-12 py-2">
                <el-input
                    clearable
                    type="text"
                    placeholder="Nombre"
                    v-model="searchName"
                />
              </div>
              <div class="col-md-3 col-12">
                <el-select v-model="searchProvince" class="m-2" placeholder="Provincia" size="large" clearable>
                  <el-option
                      v-for="item in provinces"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  />
                </el-select>
              </div>
              <div class="col-md-3">
                <button
                    @click="handleSearch"
                    class="
                      float-start
                      btn btn-primary
                      text-white
                      bg-blue-600
                      rounded-lg
                      border border-primary
                      hover:bg-blue-900
                      mt-2
                    ">
                  Buscar
                </button>
              </div>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                <tr>
                  <th
                    class="
                        text-uppercase text-custom text-xxs
                        font-weight-bolder
                        opacity-7
                      "
                  >
                    Nombre
                  </th>
                  <th
                      class="
                        text-uppercase text-custom text-xxs
                        font-weight-bolder
                        opacity-7
                      "
                  >
                    Provincia
                  </th>
                  <td class="d-none d-lg-table-cell text-center"></td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in naturals" :key="item.id">
                  <td>
                    <div class="d-flex px-2 py-1">
                      <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-sm">
                          <router-link
                            :to="{
                                name: 'Detalle-Natural',
                                params: { id: item.id },
                              }"
                          >
                            {{ item.name }}
                          </router-link>
                        </h6>
                          <div class="d-block d-lg-none">
                            <router-link
                                class="btn btn-link text-dark px-3 mb-0"
                                :to="{
                                      name: 'Actualizar-Natural',
                                      params: { id: item.id },
                                      }"
                            >
                                <i class="fa fa-pencil text-dark me-2" aria-hidden="true"></i>Editar
                            </router-link>
                            <a
                                class="btn btn-link text-danger text-gradient px-3 mb-0"
                                href=""
                                @click="handleDelete(item['id'])"
                            >
                              <i class="far fa-trash-alt me-2" aria-hidden="true"></i>Borrar
                            </a>
                          </div>
                      </div>
                    </div>
                  </td>
                  <td>
                     {{ item.province.name }}
                  </td>
                  <td class="d-none d-lg-table-cell text-center">
                    <router-link
                        class="btn btn-link text-dark px-3 mb-0"
                      :to="{
                          name: 'Actualizar-Natural',
                          params: { id: item.id },
                        }"
                    > <i class="fa fa-pencil text-dark me-2"  aria-hidden="true"></i>Editar
                    </router-link>
                    <a
                      class="btn btn-link text-danger text-gradient px-3 mb-0"
                      href="javascript:;"
                      @click="handleDelete(item.id)"
                    >
                      <i class="far fa-trash-alt me-2" aria-hidden="true"></i
                      >Borrar
                    </a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted} from "vue";
import {useStore} from "vuex";
import {ElMessageBox} from "element-plus";
import { ref } from "vue";
    const store = useStore();
   const provinces = computed(() => store.state.province.provinces);
const searchName = ref("");
const searchProvince = ref("");
const getProvinces = async () => {
  return await store.dispatch("province/getList");
};
const handleSearch = () => {
  store.dispatch("natural/getNaturals", {
      name: searchName.value,
      'provinceId': searchProvince.value
  });
};
    const getNaturals = async () => {
      return await store.dispatch("natural/getNaturals");
    };

    onMounted(()=> {
      getNaturals()
      getProvinces()
    });

    const naturals = computed(() => store.state.natural.naturals);

    const deleteNatural = async (position) => {
      try {
        await store.dispatch("natural/deleteNatural", position).then(async () => {
          await getNaturals();
        });
      } catch (error) {
        console.log(error);
      }
    };

    const handleDelete = (item) => {
      ElMessageBox.confirm("¿Estás seguro que deseas eliminar el registro?")
        .then(() => {
          deleteNatural(item);
        })
        .catch(() => {
          // catch error
        });
    };

</script>
